import React from 'react';
import get from 'lodash/get';

class Metadata extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mostrarMotivos: false,
      motivoSelected: [],
      siStyle: 'motivo',
      noStyle: 'motivo',
      firstTime: false
    };
  }

  seleccionarVisita(i) {
    if (i === 1) {
      this.setState({
        siStyle: 'motivo selected',
        noStyle: 'motivo',
        mostrarRecomendacion: true
      });
    } else {
      this.setState({
        noStyle: 'motivo selected',
        siStyle: 'motivo',
        mostrarRecomendacion: true
      });
    }
    this.props.updateVisit(i);
    if (!this.state.firstTime) {
      this.setState({ firstTime: true });
    }
  }

  seleccionarMotivos(i, value) {
    let motivoSelected = this.state.motivoSelected;
    if (motivoSelected.includes(i)) {
      motivoSelected = motivoSelected.filter(filter => filter !== i);
    } else {
      motivoSelected.push(i);
    }

    motivoSelected = motivoSelected.slice(-1);

    this.setState({
      motivoSelected
    });
    this.props.updateReferral(value);
  }
  render() {
    return (
      <div style={{ position: 'absolute', width: '100%', top: '30%' }}>
        <div className={'principal'}>
          <div
            style={{ paddingLeft: '18px', paddingRight: '18px' }}
            className={'pregunta'}
          >
            Es la primera vez que nos visitas?
          </div>
        </div>
        <div className={'tabla'}>
          <button
            onClick={() => this.seleccionarVisita(1)}
            key={1}
            className={this.state.siStyle}
          >
            SI
          </button>
          <button
            style={{ marginLeft: '34px'}}
            onClick={() => this.seleccionarVisita(2)}
            key={2}
            className={this.state.noStyle}
          >
            NO
          </button>
        </div>
        {this.state.mostrarRecomendacion ? (
          <div>
            <div className={'principal'}>
              <div
                style={{ marginBottom: '25px', marginTop: '43px' }}
                className={'pregunta'}
              >
                Como nos conociste?
              </div>
            </div>
            <div className={'tabla'}>
              <div className={'motivos'}>
                {get(
                  this.props,
                  'encuesta.metadata.settings.referral.options',
                  [
                    {
                      value: 'Otro'
                    }
                  ]
                ).map((option, i) => (
                  <button
                    style={{ minWidth: '137px !important' }}
                    key={i}
                    className={
                      this.state.motivoSelected.includes(i)
                        ? 'motivoMetadata selected'
                        : 'motivoMetadata'
                    }
                    onClick={() => this.seleccionarMotivos(i, option.value)}
                  >
                    {option.value}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Metadata;
